import Fetch from "utils/fetch"
import { generateQueryParams } from "../../../utils/custom-functions"

export const getOrderVolume = (params) => {
 return  Fetch.get(`/volume-orders:cards-paginated?${generateQueryParams(params)}`).then(({ data }) => data)
}

export const accept = (ids) =>
  Fetch.post(`/volume-orders:accept`, ids).then(({ data }) => data)
